
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evenement/[slug]",
      function () {
        return require("private-next-pages/evenement/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evenement/[slug]"])
      });
    }
  